export default __webpack_public_path__ + "assets/manager-promotion1-phone-no-shadow-2x.png";